<template>
    <div class="max-width-content">
        <trashed-message v-if="tag.deleted_at" class="mb-6" @restore="restore">
            This tag has been deleted.
        </trashed-message>

        <div class="flex items-center justify-between">
            <breadcrumbs>
                <inertia-link href="/tags">Tags</inertia-link>
                <i class="fad fa-chevron-right"></i>
                {{ tag.name | truncate(35) }}
            </breadcrumbs>

            <div v-if="!tag.deleted_at">
                <link-button :href="route('admin.tags.edit', tag.id)" icon="pencil" class="bg-white">Wijzig</link-button>
                <link-button :href="route('admin.tags.create')" icon="plus" class="bg-white">Nieuwe tag</link-button>
                <confirm-button method="delete" :href="route('admin.tags.destroy', tag.id)" icon="trash" class="bg-white hover:bg-red-600 hover:text-white">Verwijder</confirm-button>
            </div>
        </div>

        <div class="mt-8">
            <h1 class="text-5xl text-teal-800 mr-1 leading-tight mt-3">{{ tag.name }}</h1>

            <div class="mb-3"><i class="fal mr-1" :class="tag.categoryIcon"></i>{{ tag.category.name }}</div>

            <div class="bg-white px-5 py-3 rounded-lg styled-content">
                <h2 class="text-xl font-humboldt-bold">SEO teksten</h2>

                <div class="mt-3">
                    <span class="text-base font-humboldt-bold">Title:</span>
                    <div v-if="tag.seo_title" v-html="tag.seo_title"></div>
                    <div v-else>Er is nog geen title description.</div>
                </div>

                <div class="mt-3">
                    <span class="text-base font-humboldt-bold">Meta description:</span>
                    <div v-if="tag.seo_description" v-html="tag.seo_description"></div>
                    <div v-else>Er is nog geen SEO meta description.</div>
                </div>

                <div class="mt-3">
                    <span class="text-base font-humboldt-bold">SEO tekst boven:</span>
                    <div v-if="tag.seotext1" v-html="tag.seotext1"></div>
                    <div v-else>Er is nog geen SEO tekst voor boven.</div>
                </div>

                <div class="mt-5">
                    <span class="text-base font-humboldt-bold">SEO tekst onder:</span>
                    <div v-if="tag.seotext2" v-html="tag.seotext2"></div>
                    <div v-else>Er is nog geen SEO tekst voor onder.</div>
                </div>
            </div>
        </div>

        <div class="mt-10">
            <h2 class="text-2xl">Aliases</h2>
            <p>When scraping, use these tag alliases to match this tag.</p>

            <div class="bg-white rounded-lg flex flex-wrap items-center px-3 py-1 mt-3 mb-3">
                <div>
                    <i class="fad fa-tags"></i>
                    <span class="font-humboldt-bold mr-1">Aliasses:</span>
                </div>

                <a
                    v-for="(alias, key) in tag.aliases"
                    class="group mr-1 mb-1 px-3 mt-1 py-1 rounded bg-teal-200 cursor-pointer hover:line-through"
                    @click.prevent()="removeAlias(alias)"
                >
                    {{ alias.slug }}
                </a>

                <div class="flex  px-2 rounded items-center">
                    <i class="fad mr-1" :class="this.loading === 'addTag' ? 'fa-spinner fa-spin' : 'fa-plus-circle'"></i>

                    <input type="text" v-model="aliasToAdd" class="bg-gray-100 border border-teal-400 rounded py-1 px-2" @keyup="replaceSpace()" @keyup.enter="addAlias()" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import TrashedMessage from "@/admin/Shared/TrashedMessage";
import TagForm from "@/admin/Pages/Tags/TagForm";
import LinkButton from "@/admin/Shared/LinkButton";
import ConfirmButton from "@/admin/Shared/ConfirmButton";

export default {
    metaInfo() {
        return { title: this.tag.name };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        TrashedMessage,
        Breadcrumbs,
        LinkButton,
        ConfirmButton,
    },

    mixins: [Helpers],

    props: {
        tag: Object
    },

    data() {
        return {
            aliasToAdd: ""
        };
    },

    methods: {
        replaceSpace() {
            this.aliasToAdd = this.aliasToAdd.replace(/ /g, "-");
        },

        removeAlias(alias) {
            this.loading = "removeAlias";
            const url = this.route("admin.tags.aliases.destroy", this.tag.id) + "?id=" + alias.id
            const options = { onFinish: () => this.loading = false }

            this.$inertia.delete(url, options)
        },

        addAlias() {
            this.loading = "addAlias";

            const url = this.route("admin.tags.aliases.store", this.tag.id);
            const data = { alias: this.aliasToAdd };
            const options = { onFinish: () => {
                    this.aliasToAdd = ""
                    this.loading = ""
                }
            }

            this.$inertia.post(url, data, options)

        },


        restore() {
            this.loading = "restore";
            if (confirm("Are you sure you want to restore this tag?")) {
                const url = this.route("admin.tags.restore", this.tag.id)
                const options = { onFinish: () => this.loading = false }

                this.$inertia.patch(url, options);
            }
        }
    }
};
</script>
